export default __webpack_public_path__ + "static/media/up_doc_1.60ee72f0.png";